import React, { useEffect, useContext, useState } from "react";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faSpinner } from "@fortawesome/free-solid-svg-icons";

const DataForMoneyTransferModal = (props) => {
    const { t } = useTranslation();
    const { onClose } = props;
    const { checkServerData, setAlerts } = useContext(BasicContext);
    const [mtData, setMtData] = useState(null); //mt - money transfer
    const [loading, setLoading] = useState(true);

    const getData = async (c) => {
        const res = await postMethod("/get-data-for-money-transfer");
        if (checkServerData(res)) {
            setMtData(res.data.mtData);
        }
        setLoading(false);
    };

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, []);

    return (
        <Modal show={true} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{t("payments.dataForMoneyTransfer")}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-3">
                <Container fluid>
                    <Row>
                        {loading ? (
                            <Col xs={12}>
                                <p className="fs-5 text-center my-3">
                                    {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                </p>
                            </Col>
                        ) : (
                            mtData && (
                                <Col xs={12}>
                                    <p className="mb-1">
                                        {t("payments.receiver")}: <strong>{mtData.accountName}</strong>
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            className="d-inline-block ms-2"
                                            onClick={() => {
                                                navigator.clipboard.writeText(mtData.accountName);
                                                setAlerts([{ variant: "info", message: t("info.copiedToClipboard"), fading: 1000, id: "copyClipboardreceiver" }]);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faCopy} />
                                        </Button>
                                    </p>
                                    <p className="mb-1">
                                        {t("payments.accountNumber")}: <strong className="text-small">{mtData.accountNumber.replace(/(\d{4})(?=\d)/g, "$1 ")}</strong>
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            className="d-inline-block ms-2"
                                            onClick={() => {
                                                navigator.clipboard.writeText(mtData.accountNumber);
                                                setAlerts([{ variant: "info", message: t("info.copiedToClipboard"), fading: 1000, id: "copyClipboardaccountNumber" }]);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faCopy} />
                                        </Button>
                                    </p>
                                    <p className="mb-1 mt-3">
                                        {t("payments.moneyTransferTitle")}: <i>{t("passes.passName")}</i> (<i>{t("payments.orderNumber")}</i>)
                                    </p>
                                </Col>
                            )
                        )}
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={onClose}>
                    {t("close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DataForMoneyTransferModal;
